import React, { useState, memo } from 'react';
import { map } from 'lodash';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

const CustomSelect = props => {
  const [value, setValue] = useState(props.value);

  return (
    <FormControl fullWidth>
      <InputLabel htmlFor={props.id}>{props.label}</InputLabel>
      <Select
        value={value}
        multiple={Boolean(props.multiple)}
        inputProps={{ name: props.label, id: props.idm }}
        onChange={e => {
          props.onChange(e);
          setValue(e.target.value);
        }}
      >
        <MenuItem value={''}>None</MenuItem>
        {map(props.enum, ({ value, label }) => (
          <MenuItem key={`${props.id}-${value}`} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default memo(CustomSelect, () => true);
